import React, { useState, useEffect } from 'react';
import { CModal, CModalBody, CButton, CModalTitle, CFormCheck, CRow, CCol } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import cloneDeep from 'lodash/cloneDeep';

const ModalShowField = (props) => {
     const { visible, onClose, itemPerPage, setItemPerPage, fields, setFields, listFields, defaultField } = props;
     const defaultFields = cloneDeep(listFields);
     const [selectedFields, setSelectedFields] = useState([]); // Change initial state to empty array instead of all selected
     const [pageSize, setPageSize] = useState(itemPerPage); // Default to 300 items

     useEffect(() => {
          const currentFieldKey = fields.map((field) => field.key)
          const currentFields = defaultFields.map((field) => {
               return { key: field.key, label: field.label, status: currentFieldKey.includes(field.key) }
          }).filter((item) => item.label)
          setSelectedFields(currentFields); 
     }, [fields]); // eslint-disable-line

     const handleFieldSelect = ({ key, checked }) => {
          setSelectedFields(prev => {
               const keyIndex = prev.findIndex(item => item.key === key);
               if (keyIndex === -1) return prev;

               const newFields = [...prev];
               newFields[keyIndex] = { ...newFields[keyIndex], status: checked };

               return newFields;
          });
     };

     const handleSelectAll = (checked) => {
          const currentFields = defaultFields.map((field) => {
               return { key: field.key, label: field.label, status: checked }
          }).filter((item) => item.label);

          setSelectedFields(currentFields)
     };

     const handleSubmit = () => {
          setItemPerPage(pageSize);
          const selectField = selectedFields.filter((field) => field.status).map(field => field.key);
          const newFields = listFields.filter((field) => selectField.includes(field.key));
          newFields.push(...defaultField);
          setFields(newFields);
          onClose();
     };

     const handlePageSizeChange = (value) => {
          setPageSize(parseInt(value));
     };

     return (
          <CModal
               visible={visible}
               backdrop='static'
               alignment='center'
               keyboard={false}
               portal={false}
               onClose={onClose}
               size='lg'
               className={`import-modal`}
          >
               <CModalBody>
                    <div className='import-modal-body'>
                         <CIcon name='cil-x' onClick={onClose} className='icon-close-popup' />
                         <CModalTitle>Settings</CModalTitle>

                         <CRow>
                              <CCol xs={6}>
                                   <div className="page-size-section">
                                        <h6 className="mb-3">Page Size</h6>
                                        {[10, 25, 50, 100, 200, 300].map((size) => (
                                             <CFormCheck
                                                  key={size}
                                                  type="radio"
                                                  name="pageSize"
                                                  id={`pageSize${size}`}
                                                  label={`${size} items`}
                                                  checked={pageSize === size}
                                                  onChange={() => handlePageSizeChange(size)}
                                                  className="mb-2"
                                             />
                                        ))}
                                   </div>
                              </CCol>
                              <CCol xs={6}>
                                   <CFormCheck
                                        id="selectAll"
                                        label="Select All Fields"
                                        checked={selectedFields.every((field) => field.status)}
                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                        className="mb-3 font-weight-bold"
                                   />
                                   {selectedFields.map((field, index) => (
                                        <div key={index} className='py-2'>
                                             <CFormCheck
                                                  id={`field-${index}`}
                                                  checked={field.status}
                                                  onChange={(e) => handleFieldSelect({ key: field.key, checked: e.target.checked })}
                                                  label={
                                                       <div className="d-flex justify-content-between w-100">
                                                            <span>{field.label}</span>
                                                       </div>
                                                  }
                                             />
                                        </div>
                                   ))}
                              </CCol>
                         </CRow>

                         <div className='import-modal-button'>
                              <CButton
                                   color='primary'
                                   onClick={handleSubmit}
                                   disabled={selectedFields.length === 0}
                              >
                                   Save changes
                              </CButton>
                              <CButton color='light' type='button' onClick={onClose}>
                                   CANCEL
                              </CButton>
                         </div>
                    </div>
               </CModalBody>
          </CModal>
     );
};

export default ModalShowField;
